import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["value"];
import React from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Static');
function Static(_ref) {
  let {
      value
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Text, _extends({
    className: classes.root
  }, props), value);
}
export default /*#__PURE__*/React.memo(Static);